import { Chip } from "@mui/material"
import type { FC } from "react"

interface PreferredBadgeProps {
  testId?: string
}

export const PreferredBadge: FC<PreferredBadgeProps> = ({ testId }) => {
  return (
    <Chip
      label='Preferred'
      size='small'
      className='h-6 shrink-0 rounded bg-primary-200 px-1 text-xs text-gray-700'
      data-testid={testId}
    />
  )
}
